<template>
  <div id="legal" class="page">
    <!-- <div class="head-wrapper">
      <h2 class="head-copy">Legal</h2>
    </div> -->

    <div id="legal-header">
      <div id="close" @click="collapseLegal"></div>

      <h2 v-if="legalState == 'legal'" class="in">Legal</h2>
      <h2 v-else class="in">Privacy/Terms</h2>
    </div>

    <div id="copy-wrapper">
      <div id="copy">
        <p>NO PURCHASE IS NECESSARY TO ENTER OR WIN. A PURCHASE DOES NOT INCREASE THE CHANCES OF WINNING.</p>
        
        <ol>
          <li>Eligibility: This Campaign is open only to those who sign up at the <a href="https://bit.ly/2y188uN" >https://bit.ly/2y188uN</a> and who have reached the age of majority in their province or territory of residence as of the date of entry. The Campaign is only open to legal residents of Canada excluding Quebec, and is void where prohibited by law. Employees including directors, officers, agents and representatives of Hershey Canada Inc, its affiliates, subsidiaries, advertising and promotion agencies, and suppliers, (collectively the “Employees”), and immediate family members (including mother, father, brothers, sisters, sons, daughters, partner or legal or common-law spouse) and/or those living in the same household of Employees are not eligible to participate in the Campaign. The Campaign is subject to all applicable federal, provincial, territorial and local laws and regulations. Void where prohibited.
          </li>
          
          <li>Agreement to Rules: By participating, the Contestant (“You”) agree to be fully unconditionally bound by these Rules, and You represent and warrant that You meet the eligibility requirements. In addition, You agree to accept the decisions of Hershey Canada Inc as final and binding as it relates to the content of this Campaign. By providing personal information, such as name, address and telephone number, the contestant consents to the collection, use and disclosure of his or her personal information in accordance with the terms of Hershey&#39;s Privacy Policy, that a Winner consents to have his or her name published in connection with the Campaign, and that the contestant may opt out / withdraw his or her consent by following the steps set out in the Privacy Policy.
          </li>
          
          <li>Campaign Period: Entries will be accepted online starting on March 8 2021 at 12:00:01 AM Eastern Time (ET) and ending April 4 2021 at 11:59:59 PM (ET). All online entries must be received by April 12 2021 at 11:59:59 PM (ET)
          </li>
          
          <li>How to Enter: The Campaign must be entered by submitting an entry using the online form provided at <a href="https://bit.ly/2y188uN" >https://bit.ly/2y188uN</a>, which can be accessed after collecting all ten Reese Easter eggs in the Snapchat lens. The entry must fulfill all Campaign requirements, as specified, to be eligible to win a prize. Entries that are incomplete or do not adhere to the rules or specifications may be disqualified at the sole discretion of Hershey Canada Inc. You may enter only once per day. You must provide the information requested, which includes: name, E-mail address, phone number, city, country, postal code and answer a skill testing question. You may not enter more times than indicated by using multiple email addresses, identities, or devices in an attempt to circumvent the rules. If You use fraudulent methods or otherwise attempt to circumvent the rules, your submission may be removed from eligibility at the sole discretion of Hershey Canada Inc.
          </li>
          
          <li>Prizes: The Winner(s) of the Campaign (the “Winner”) will receive either 1 bag of REESE Easter Chocolate Candy Peanut Butter Eggs, 185 Gram, approximate value CAD $5.00 each, 1 bag of REESE Easter Chocolate Candy Peanut Butter Eggs, 670g, approximate value CAD $14.00 each, HERSHEY Chocolate Crème 3D Candy Egg, 34g, approximate value CAD $1.25 or HERSHEY COOKIES N CRÈME 3D Candy Egg 4 Pack, 136g, approximate value CAD $4.79. Actual/appraised value may differ at time of prize award.
          </li>
          
          <li>The specifics of the prize shall be solely determined by Hershey Canada Inc, and Hershey reserves the right to substitute another prize of equal or greater value, without liability. No cash or other prize substitution shall be permitted except at Hershey Canada Inc discretion. No substitution of prize or transfer/assignment of prize to others or request for the cash equivalent by Winner is permitted.
          </li>
          
          <li>1,134 Prizes available to be won, each consisting of 1 bag of REESE Easter Chocolate Candy Peanut Butter Eggs, 185 Gram (approx. retail value of each: CAD $5.00), 1 bag of REESE Easter Chocolate Candy Peanut Butter Eggs, 670g (approximate value CAD $14.00 each), HERSHEY Chocolate Crème 3D Candy Egg, 34g (approximate value CAD $1.25) or HERSHEY COOKIES N CRÈME 3D Candy Egg 4 Pack, 136g (approximate value CAD $4.79). Odds of winning depend on the number of eligible entries received before April 4, 2021. Mathematical skill-testing question required.
          </li>
          
          <li>Winner Selection and Notification: To be declared a Winner, You must successfully collect all six Reese Easter eggs in each level within the Snapchat lens, which will then prompt you to enter the microsite where You must fill out all information required. The selected entrant must also answer correctly, without assistance of any kind, whether mechanical or otherwise, a time-limited mathematical skill testing question. Once completed, Winner will be randomly selected within the website and will be instantly notified if they are deemed a winner on the website. If selected as a Winner, user cannot win a second time, but can continue to play the Egg Hunt game within the Snapchat lens. Up to 1,134 winners will be randomly selected. Hershey Canada Inc shall have no liability for Winner’s failure to receive notices due to spam, junk e-mail or other security settings or for Winner’s provision of incorrect or otherwise non-functioning contact information. If Winner cannot be contacted, is ineligible, or fails to timely return a completed and executed declaration and release as required, the prize may be forfeited and an alternate Winner selected in accordance with the procedure set out above. Receipt by Winner of the prize offered in this Campaign is conditioned upon compliance with any and all federal, provincial, territorial and local laws and regulations. ANY VIOLATION OF THESE OFFICIAL RULES BY WINNER (AT Hershey Canada Inc‘S SOLE DISCRETION) WILL RESULT IN WINNER’S DISQUALIFICATION AS WINNER OF THE CAMPAIGN, AND ALL PRIVILEGES AS WINNER WILL BE IMMEDIATELY TERMINATED.
          </li>
          
          <li>Terms &amp; Conditions: Hershey Canada Inc reserves the right, in its sole discretion, to cancel, terminate, modify or suspend the Campaign should virus, bug, non-authorized human intervention, fraud, or other cause beyond Hershey Canada Inc’s control corrupt or affect the administration, security, fairness, or proper conduct of the Campaign. In such case, Hershey Canada Inc may select the Winner from all eligible entries received prior to and/or after (if appropriate) the action taken by Hershey Canada Inc. Hershey Canada Inc reserves the right, in its sole discretion, to disqualify any individual who tampers or attempts to tamper with the entry process or the operation of the Campaign or website or violates these Terms &amp; Conditions. Hershey Canada Inc has the right, in its sole discretion, to maintain the integrity of the Campaign, to void entries for any reason, including, but not limited to: multiple entries from the same user from different IP addresses; multiple entries from the same computer in excess of that allowed by Campaign rules; or the use of bots, macros, scripts, or other technical means for entering. Any attempt by an entrant to deliberately damage any website or undermine the legitimate operation of the Campaign may be a violation of criminal and civil laws. Should such attempt be made, Hershey Canada Inc reserves the right to seek damages to the fullest extent permitted by law.
          </li>
          
          <li>Limitation of Liability: By entering, You agree to release and hold harmless Hershey Canada Inc and its subsidiaries, affiliates, advertising and promotion agencies, partners, representatives, agents, successors, assigns, employees, officers, and directors from any liability, illness, injury, death, loss, litigation, claim, or damage that may occur, directly or indirectly, whether caused by negligence or not, from: (i) such entrant’s participation in the Campaign and/or his/her acceptance, possession, use, or misuse of any prize or any portion thereof; (ii) technical failures of any kind, including but not limited to the malfunction of any computer, cable, network, hardware, or software, or other mechanical equipment; (iii) the unavailability or inaccessibility of any transmissions, telephone, or Internet service; (iv) unauthorized human intervention in any part of the entry process or the Promotion; (v) electronic or human error in the administration of the Promotion or the processing of entries.
          </li>
          
          <li>Disputes: THIS Campaign IS GOVERNED BY THE LAWS OF THE PROVINCE OF ONTARIO AND THE LAWS OF CANADA APPLICABLE THEREIN, WITHOUT RESPECT TO CONFLICT OF LAW DOCTRINES. As a condition of participating in this Campaign, participant agrees that any and all disputes that cannot be resolved between the parties, and causes of action arising out of or connected with this Campaign, shall be resolved individually, without resort to any form of class action, exclusively before a court located in Ontario, Canada having jurisdiction. Further, in any such dispute, under no circumstances shall participant be permitted to obtain awards for, and hereby waives all rights to, punitive, incidental, or consequential damages, including reasonable attorney’s fees, other than participant’s actual out-of-pocket expenses (i.e. costs associated with entering this Campaign). Participant further waives all rights to have damages multiplied or increased. Some jurisdictions do not allow the exclusion or limitation of incidental or consequential damages, therefore, such exclusions may not apply toYou.
          </li>
          
          <li>Privacy Policy: Information submitted with an entry is subject to the Privacy Policy stated onthe Hershey Canada Inc website. To read the Privacy Policy, click <a href="https://www.thehersheycompany.com/en_us/home/privacy-policy.html" target="_blank">here</a>. [Note: a privacy policy is optional, but may be required when running a promotion on the web when using third party platforms or when using features from social channels. Including this information makes it clear to your users how you are going to use their information.]
          </li>
          
          <li>General: By participating in the Campaign, you agree that Hershey Canada Inc. has not made, with respect to each of its own products / services provided as a prize or part thereof (if applicable), any warranty, representation or guarantee express or implied, in fact or in law, with respect to the prize and specifically disclaim all such warranties, including without limitation, the implied warranties of merchantability and fitness for a particular purpose. Winning a prize is contingent on fulfilling all the requirements set forth herein. You agree to abide by these Rules. Hershey reserves the right to correct any typographical, printing, computer programming or operator errors. Hershey&#39;s failure to enforce any term of these Rules shall not constitute a waiver of that provision. The invalidity or unenforceability of any provision of these Rules shall not affect the validity or enforceability of any other provision. If any provision of the Rules is determined to be invalid or otherwise unenforceable, then the Rules shall be construed in accordance with their terms as if the invalid or unenforceable provision was not contained therein. Hershey reserves the right, in its sole and absolute discretion, to administer an alternate test of skill as it deems appropriate or necessary to comply with applicable law.
          </li>
          
          <li>Sponsor: The Sponsor of the Campaign is Hershey Canada Inc., 5750 Explorer Dr, Mississauga, Ontario L4W 0B1 Canada.
          </li>
        </ol>
        

      </div>
    </div>

  </div>
</template>

<script>
import { mapMutations } from 'vuex';
import { mapGetters } from 'vuex';

export default {
  name: 'Legal',

  mounted(){
    console.log('grecaptcha: ', window);
  },

  computed: {
    ...mapGetters([
      'legalState',
      // 'isWinner',
    ])
  },

  methods: {
    ...mapMutations([
      'showLegal'
    ]),

    collapseLegal(){
      console.log('call coll')
      let payload = {
        visibilityFlag: false,
      }

      this.showLegal(payload);
    }
  }

}
</script>

<style lang="scss">
@import "../styles/_mixins.scss";

  #legal {
    position: absolute;
    top: 7.5vh;
  }

  #close {
    position: absolute;
    right: 0;
    top: 0;
    height: 17.5px;
    width: 17.5px;
    cursor: pointer;
    z-index: 10;
    margin-right: 20px;

    background-image: url('../../public/assets/close_icon.png');
    background-size: contain;
    background-repeat: no-repeat;

  }

  #legal-header {
    height: 10vh;
    position: relative;
    display: flex;
    align-content: center;
    justify-content: center;
    align-items: center;

    h2 {
      margin: 0;
    }

  }

  #copy-wrapper {
    height: 55vh;
    overflow: hidden;
  }

  #copy {
    overflow-y: scroll;
    height: 100%;
    width: 100%;
    font-family: Arial, Helvetica, sans-serif;
    font-weight: 600;


    p {
      // font-family: Arial, Helvetica, sans-serif;
      font-size: 1em;
      font-weight: 800;
      color: black;
      text-transform: none;
      text-align: left;
      margin-bottom: 0.5em;
    }

    ol {
      font-family: inherit;
      font-weight: inherit;
      text-align: left;
      padding-right: 2.5em;


      li {

        margin-bottom: 1em;

      }

    }

  }

</style>
